import { render } from "./VDateTime.vue?vue&type=template&id=2dc20f8c&scoped=true"
import script from "./VDateTime.vue?vue&type=script&lang=js"
export * from "./VDateTime.vue?vue&type=script&lang=js"

import "./VDateTime.vue?vue&type=style&index=0&id=2dc20f8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc20f8c"]])

export default __exports__